import { FlexRow, CustomContainer, AppSpan, AppText } from "src/style"
import helpers from "src/utils/helpers"
import {ReactComponent as VerifiedIcon} from 'src/assets/svg/verified-icon.svg'
import {ReactComponent as UnverifiedIcon} from 'src/assets/svg/unverified-icon.svg'

export const CustomerInfo: React.FC<any> = ({customer}) => {
    const isAddressVerified = customer?.verificationStatus === 'VERIFIED'

    return (
        <FlexRow 
            gap="2" justifyContent="space-between" 
            alignItems="flex-start"
            className='dashboard-charts-container'
        >
            <CustomContainer
                minHeight="60" radius="0.4"
                padding="2.5" bgColor="#ffffff"
                shadow='0px 10px 50px 0px #0000000D'
                width="67.5" sizeUnit="%"
                className='dashboard-chart-wrapper'
            >
                <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                    Personal Information
                </AppSpan>
                <FlexRow 
                    topMargin="2" wrap="wrap"
                    justifyContent="space-between" 
                    gap="5" alignItems="flex-start"
                >
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>First Name</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.firstName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Last Name</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.lastName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Email Address</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.emailAddress}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>User ID</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.id}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Phone Number</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.mobileNo}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Platform</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.platform}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Date Created</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.dateCreated ? helpers.splitDateTime(customer?.dateCreated)?.date : ''}</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Property Name</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">Unavailable</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Last Login</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">Unavailable</AppText>
                    </CustomContainer>
                    <CustomContainer width="20" sizeUnit="">
                        <AppSpan>Address Provided</AppSpan>
                        <AppText color="#1D1D1D" fontWeight="500">{customer?.initialAddress?.address}</AppText>
                    </CustomContainer>
                </FlexRow>
            </CustomContainer>

            <CustomContainer 
                width="30" sizeUnit="%"
                className='dashboard-chart-wrapper'
            >
                <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                    Address Verification Status
                </AppSpan>
                <FlexRow 
                    topMargin="2" padding="2" gap="1"
                    borderColor={isAddressVerified ? "#219653" : "#E2B93B"}
                    minHeight="12.7" radius="0.4"
                >
                    {
                        isAddressVerified ?
                            <VerifiedIcon className="icon-component" />
                            :
                                <UnverifiedIcon className="icon-component" />
                    }
                    <CustomContainer width="auto" sizeUnit="">
                        <AppSpan textSize="1.6" fontWeight="700" color="#1D1D1D">
                            {isAddressVerified ? 'Address Verified' : 'Address Unverified'}
                        </AppSpan>
                        <AppText>{isAddressVerified ? '28th August, 2021' : 'Please verify user'}</AppText>
                    </CustomContainer>
                </FlexRow>
            </CustomContainer>
        </FlexRow>
    )
}